<template>
  <div id="user-edit-tab-info">

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">

        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">Datos personales</span>
          </div>
          <vs-divider />
        </div>

        <div class="mt-4">
          <label>Rol</label>
          <div class="flex flex-wrap mt-3 mb-6">
            <vs-radio :disabled="true" v-model="data_local.profile_type" vs-value="3" class="mr-4">Admin Cafetería</vs-radio>
            <vs-radio :disabled="true" v-model="data_local.profile_type" vs-value="6" class="mr-4">Admin Escuela</vs-radio>
            <vs-radio :disabled="true" v-model="data_local.profile_type" vs-value="7" class="mr-4">Admin Tienda</vs-radio>
          </div>
        </div>

        <vs-input class="w-full mt-4" label="Nombre" v-model="data_local.name" v-validate="'required|alpha_spaces'" name="name" autofocus autocomplete="off"/>
        <span class="text-danger text-sm"  v-show="errors.has('name')">{{ errors.first('name') }}</span>

        <vs-input class="w-full mt-4" label="Apellido" v-model="data_local.last_name" v-validate="'required|alpha_spaces'" name="last_name" autocomplete="off"/>
        <span class="text-danger text-sm"  v-show="errors.has('last_name')">{{ errors.first('last_name') }}</span>

        <div class="mt-4 flex flex-wrap">
          <div class="w-1/2">
            <vs-input class="w-full" label="Email" :disabled="true" v-model="data_local.email" type="email" v-validate="'required|email'" name="email" autocomplete="off"/>
            <span class="text-danger text-sm"  v-show="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
          <div class="w-1/2">
            <vs-input label="Teléfono" class="w-full pl-4" v-model="data_local.phone_number" name="phone_number" placeholder="Número de teléfono" autocomplete="off"/>
            <span class="text-danger text-sm"  v-show="errors.has('phone_number')">{{ errors.first('phone_number') }}</span>
          </div>
        </div>

        <div class="mt-4 flex flex-wrap">
          <label class="vs-input--label w-full">Documento de identidad</label>
          <!-- <v-select :clearable="false" :options="cardTypeOptions" @input="updateCardType($event)" v-model="data_local.card_type_id" v-validate="'required'" class="w-1/4" name="card_type_id" placeholder="Tipo" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
          <div class="w-1/2">
            <v-select browserAutocomplete="off" autocomplete="off" v-model="data_local.card_type_id" :reduce="card_type_id => card_type_id.value" :options="cardTypeOptions" :clearable="false" v-validate="'required'" name="card_type_id" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <!-- <vs-select :clearable="false"  v-validate="'required'" v-model="data_local.card_type_id" name="card_type_id" placeholder="Tipo" :dir="$vs.rtl ? 'rtl' : 'ltr'">
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in cardTypeOptions" />
            </vs-select> -->
          </div>
          <span class="text-danger text-sm"  v-show="errors.has('card_type_id')">{{ errors.first('card_type_id') }}</span>
          <div class="w-1/2 pl-4">
            <vs-input class="w-full" v-model="data_local.card_id" v-validate="'required|max:15'" name="card_id" placeholder="Número" autocomplete="off"/>
            <span class="text-danger text-sm"  v-show="errors.has('card_id')">{{ errors.first('card_id') }}</span>
          </div>
        </div>

        <div class="mt-4">
          <label>Fecha de nacimiento</label>
          <div class="flex flex-wrap">
            <datepicker :disabledDates="disabledDates" :useUtc="true" :openDate="openDate" :format="dateFormat" v-model="birthdayLocal" v-validate="'required'" name="birthday_date"></datepicker>
            <span class="text-danger text-sm"  v-show="errors.has('birthday_date')">{{ errors.first('birthday_date') }}</span>
          </div>
        </div>

        <div class="mt-4 flex flex-wrap">
          <vs-input class="w-1/2" label="Dirección" v-model="data_local.address" name="address"  autocomplete="off"/>
          <span class="text-danger text-sm"  v-show="errors.has('address')">{{ errors.first('address') }}</span>
          <vs-input class="w-1/4 pl-4" label="Ciudad" v-model="data_local.city" name="city" placeholder="Ciudad" autocomplete="off"/>
          <span class="text-danger text-sm"  v-show="errors.has('city')">{{ errors.first('city') }}</span>
          <vs-input class="w-1/4 pl-4" label="Código Postal" v-model="data_local.zip_code" name="zip_code" placeholder="Código Postal" autocomplete="off"/>
          <span class="text-danger text-sm"  v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</span>
        </div>

        <div class="mt-4 flex flex-wrap">
          <vs-input class="w-1/2" label="Empresa" v-model="data_local.company_name" name="company_name" autocomplete="off"/>
          <span class="text-danger text-sm"  v-show="errors.has('company_name')">{{ errors.first('company_name') }}</span>
          <vs-input class="w-1/2 pl-4" label="Nro. de Identificación" v-model="data_local.company_code" name="company_code" autocomplete="off"/>
          <span class="text-danger text-sm"  v-show="errors.has('company_code')">{{ errors.first('company_code') }}</span>
        </div>

      </div>

      <div v-if="data_local.profile_type == 3" class="vx-col md:w-1/2 w-full">

        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">Cuenta Bancaria</span>
          </div>
          <vs-divider />
        </div>

        <div class="mt-4">
          <label>Tipo de cuenta</label>
          <div class="flex flex-wrap mt-3 mb-6">
            <vs-radio v-model="data_local.account_type" vs-value="0" class="mr-4">Caja de Ahorro</vs-radio>
            <vs-radio v-model="data_local.account_type" vs-value="1" class="mr-4">Cuenta Corriente</vs-radio>
          </div>
        </div>

        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Nombre de la Cuenta" v-model="data_local.account_name" v-validate="'required'" name="account_name"  autocomplete="off"/>
          <span class="text-danger text-sm"  v-show="errors.has('account_name')">{{ errors.first('account_name') }}</span>
        </div>

        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Banco" v-model="data_local.bank_name" v-validate="'required'" name="bank_name"  autocomplete="off"/>
          <span class="text-danger text-sm"  v-show="errors.has('bank_name')">{{ errors.first('bank_name') }}</span>
        </div>

        <div class="mt-4">
          <vs-input class="w-full mt-4" label="Número de cuenta" v-model="data_local.bank_account" v-validate="'required'" name="bank_account"  autocomplete="off"/>
          <span class="text-danger text-sm"  v-show="errors.has('bank_account')">{{ errors.first('bank_account') }}</span>
        </div>

      </div>

    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row mt-12">
      <div class="vx-col w-full mt-12">
        <div class="mt-12 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Guardar</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'

export default {
  components: {
    Datepicker,
    'v-select': vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

      data_local: JSON.parse(JSON.stringify(this.data)),

      statusOptions: [
        { label: "Activo",  value: "1" },
        { label: "Inactivo",  value: "0" },
      ],
      bankOptions: [
        { label: "Credicorp Bank Panamá",  value: "1" },
      ],
      cardTypeOptions: [
        { label: "CEDULA", value: 1 },
        { label: "PASAPORTE", value: 2 },
      ],
      roleOptions: [
        { text: "Gerente",  value: "4" },
        { text: "Cajero",  value: "5" },
      ],

      disabledDates: {
        // to: new Date(new Date().getFullYear()-18, new Date().getMonth(), new Date().getDay()), // Disable all dates up to specific date
        from: new Date(new Date().getFullYear()-16, new Date().getMonth(), new Date().getDay()), // Disable all dates after specific date
        // daysOfMonth: [8, 11, 17], // Disable Specific days
      },
      openDate: new Date(new Date().getFullYear()-18, new Date().getMonth(), new Date().getDay(), 12, 0, 0),
      dateFormat: "dd-MM-yyyy",
    }
  },
  computed: {
    status_local: {
      get() {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set(obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get() {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set(obj) {
        this.data_local.role = obj.value
      }
    },
    birthdayLocal: {
      get() {
        // console.log('computed get', this.data_local.birthday_date.split("T")[0])
        return this.$isDate(this.data_local.birthday_date) ? this.data_local.birthday_date.toISOString().split("T")[0] : this.data_local.birthday_date.split("T")[0]
      },
      set(val) {
        // console.log('computed set val', val)
        this.data_local.birthday_date = val.toISOString().split("T")[0]
      }
    },
    validateForm() {
      return !this.errors.any() && this.data_local.card_type_id
    }
  },
  methods: {
    capitalize(str) {
      return str.slice(0,1).toUpperCase() + str.slice(1,str.length)
    },
    save_changes() {
      if(!this.validateForm) return

      this.data_local.birthday_date = this.$isDate(this.data_local.birthday_date) ? this.data_local.birthday_date.toISOString().split("T")[0] : this.data_local.birthday_date.split("T")[0],

      this.$store.dispatch('userManagement/updateUser', this.data_local)
        .then(response => {
          if (response.status) {
            this.showNotify('success', 'Usuarios', 'Datos actualizados correctamente.')
            this.$router.push('/users')
          } else {
            this.showNotify('danger', 'Usuarios', response.msg)
          }
        })
        .catch(error => this.showNotify('danger', 'Error', error))

    },
    reset_data() {
      // this.data_local = JSON.parse(JSON.stringify(this.data))
      this.$router.push("/users")
    },
    update_avatar() {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    updateProfileType(event) {
      this.data_local.profile_type = event.value
    },
    // updateCardType(event) {
    //   this.data_local.card_type_id = event.value
    // },
    showNotify(type,title,text) {
      this.$vs.notify({
        color: type || 'success',
        title: title || 'Correcto!',
        text: text || '',
        time: 8000,
        position: 'top-center',
      })
    },
  },
}
</script>
